// extracted by mini-css-extract-plugin
export default {"header":"MvHeader_header__D2G8y","select-menu":"MvHeader_select-menu__MP+Wt","btn":"MvHeader_btn__5aWYz","active":"MvHeader_active__ETtJp"};